import { parseAbsolute } from '@internationalized/date'

function getFormattedDate(rawDate: string | Date | null) {
	if (rawDate) {
		const date = typeof rawDate === 'string' ? new Date(rawDate) : rawDate

		const year = date.getFullYear()
		const month = String(date.getMonth() + 1).padStart(2, '0')
		const day = String(date.getDate()).padStart(2, '0')

		return {
			year,
			monthDigit: month,
			month: `${year}-${month}`,
			day: `${year}-${month}-${day}`,
			formatted: `${day}/${month}/${year}`,
		}
	}

	return {
		year: 0,
		monthDigit: '',
		month: '',
		day: '',
		formatted: '',
	}
}

function convertVMModelTimeStamp(rawDate: string | number | null) {
	if (rawDate === null) {
		return undefined
	}

	const d =
		typeof rawDate === 'string' ? rawDate : rawDate.toString().padStart(6, '0')

	if (d.trim() === '') {
		return undefined
	}

	const [month, year] = [d.slice(0, 2), d.slice(2)]
	const date = new Date(`${year}-${month}-01`).toISOString()

	return parseAbsolute(date, 'Europe/Rome')
}

function getTwoDigitDateFromState(rawDate: string) {
	const [month, year] = [rawDate.slice(0, 2), rawDate.slice(2)]

	return `${month}/${year}`
}

/**
 * Calculates the age in years from a BirthDate stored in state.
 * Accepts ISO format "YYYY-MM-DDTHH:mm:ss" (e.g. "2001-01-14T00:00:00").
 * Returns null when the string is missing or malformed.
 */
// Generated by GitHub Copilot
function getAgeFromBirthDate(birthDate: string): number | null {
	if (!birthDate) return null
	const parsed = new Date(birthDate)
	if (isNaN(parsed.getTime())) return null
	const today = new Date()
	let age = today.getFullYear() - parsed.getFullYear()
	if (
		today.getMonth() < parsed.getMonth() ||
		(today.getMonth() === parsed.getMonth() && today.getDate() < parsed.getDate())
	) {
		age -= 1
	}
	return age
}

export { getFormattedDate, convertVMModelTimeStamp, getTwoDigitDateFromState, getAgeFromBirthDate }
